export type Role = 'admin' | 'manager' | 'back_office' | 'employee';
export const ROLES: readonly Role[] = ['admin', 'manager', 'back_office', 'employee'];
export const ROLE_LABEL: Record<Role, string> = {
  admin: 'Quản trị', manager: 'Chủ trì', back_office: 'Back-office', employee: 'Nhân viên',
};

export interface Me { id: string; email: string; name: string; role: Role }
// `error`: không đọc được phiên/hồ sơ (mạng, máy chủ) — KHÁC `denied` (đọc được và không có quyền).
export type AuthState =
  | { status: 'loading' }
  | { status: 'signedOut' }
  | { status: 'denied'; email: string }
  | { status: 'error' }
  | { status: 'ready'; me: Me };

export interface ProfileRow { id: string; email: string | null; name: string | null; role: string | null; active: boolean }

export function resolveAccess(profile: ProfileRow | null, sessionEmail: string): AuthState {
  if (!profile || !profile.active || !ROLES.includes(profile.role as Role)) {
    return { status: 'denied', email: sessionEmail };
  }
  const email = profile.email ?? sessionEmail;
  return {
    status: 'ready',
    me: { id: profile.id, email, name: profile.name ?? email.split('@')[0], role: profile.role as Role },
  };
}
